import { useQuery } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { OnsiteCampaignResponse } from '../types';

export function useGetAllOnsiteCampaignsQuery(siteId: string) {
  const query = useQuery(['onsite-campaigns', siteId], async () => {
    const result = await RestApi.get<OnsiteCampaignResponse[]>(`/sites/${siteId}/onsite/campaigns`);
    return result.data;
  });

  return query;
}
